import {PrismicNextImage} from '@prismicio/next/pages'
import cn from 'classnames'
import type {HeroV3SliceDefaultPrimaryAssetsItem} from 'prismicio-types'

type AssetsWrapperProps = {
  assets: HeroV3SliceDefaultPrimaryAssetsItem[]
}

export const AssetsWrapper = ({assets}: AssetsWrapperProps) => (
  <div className="grid w-full grid-cols-1 max-md:mx-[-20px] max-md:w-screen max-md:max-w-none max-md:self-start md:grid-cols-[1fr,calc(50%-24px),1fr] md:gap-x-6 md:pt-14">
    {/* Mobile View */}
    <div className="flex w-full max-w-full gap-4 overflow-hidden max-md:my-6 max-md:h-[200px] md:hidden">
      <div className="flex w-max max-w-[896px] shrink-0 items-center gap-4 max-xl:animate-[slide_16s_linear_infinite]">
        {assets.map((asset, i) => (
          <PrismicNextImage key={i} field={asset.image} className="h-full w-auto rounded-[4px]" />
        ))}
      </div>
      <div className="flex w-max max-w-[896px] shrink-0 items-center gap-4 max-xl:animate-[slide_16s_linear_infinite]">
        {assets.map((asset, i) => (
          <PrismicNextImage key={i} field={asset.image} className="h-full w-auto rounded-[4px]" />
        ))}
      </div>
    </div>

    {/* Desktop View */}
    {assets.map((asset, index) => (
      <PrismicNextImage
        key={index}
        field={asset.image}
        className={cn('max-h-[282px] rounded-md bg-cover max-md:hidden', {
          'col-span-1 aspect-square max-md:hidden': index !== 1,
          'col-span-1 col-start-2 h-full': index === 1,
        })}
      />
    ))}
  </div>
)
